<template>
    <BaseView :ignoreOffline="true">
        <template v-slot:top>
            <TopNavigation />
            <SearchBar
                v-if="!initialLoading"
                @search="searchByTitle"
                :show-filter-button="false"
            />
            <inspection-count
                v-if="!initialLoading && isOnFreePlan"
                :user="user"
            />
        </template>

        <div>
            <div v-pull-to-refresh="refreshChecklists">
                <div v-if="checklists.length === 0" class="middle-of-page">
                    {{ $t("There are no inspections.") }}
                </div>

                <template v-else v-for="checklist in checklists">
                    <Checklist
                        :key="checklist.id"
                        :checklist="checklist"
                        @click.native="openDetailsModal(checklist)"
                    />
                </template>
            </div>
        </div>

        <template v-slot:bottom>
            <bottom-navigation />
        </template>

        <portal to="modals">
            <transition name="fade">
                <ChecklistDetailsModal
                    v-if="detailsModalOpen"
                    :checklist="selectedChecklist"
                    @start="conductInspection"
                    @close="closeDetailsModal"
                />
            </transition>
        </portal>
    </BaseView>
</template>

<script>
import Checklist from '@mobile/views/Checklists/Items/Checklist.vue';
import ChecklistDetailsModal from '@mobile/views/Checklists/Modals/ChecklistDetails.vue';
import TopNavigation from '@mobile/views/Checklists/components/Navigation';
import InspectionCount from '@mobile/components/InspectionCount.vue';
import { mapGetters, mapActions } from 'vuex';
import SearchBar from '@mobile/components/SearchBar.vue';
import BaseView from '@mobile/components/BaseView.vue';
import OnFreePlan from '@mobile/mixins/OnFreePlan';
import { eventBus } from '@/eventBus';

export default {
    name: 'Checklists',

    components: {
        Checklist,
        ChecklistDetailsModal,
        TopNavigation,
        SearchBar,
        BaseView,
        InspectionCount,
    },

    mixins: [
        OnFreePlan,
    ],

    props: {},

    data: () => ({
        detailsModalOpen: false,
        selectedChecklist: null,
        initialLoading: true,
    }),

    computed: {
        ...mapGetters({
            checklists: 'checklists/all',
        }),
    },

    created() {
        this.refreshChecklists();
    },

    methods: {
        ...mapActions({
            updateAll: 'checklists/updateAll',
        }),

        openDetailsModal(checklist) {
            this.selectedChecklist = checklist;
            this.detailsModalOpen = true;
        },

        closeDetailsModal() {
            this.detailsModalOpen = false;
            this.selectedChecklist = null;
        },

        conductInspection() {
            this.$router.push({
                name: 'conduct',
                params: {
                    resourceId: this.selectedChecklist.id,
                    type: 'checklist',
                },
            });
        },
        searchByTitle(value) {
            this.$store.dispatch('checklists/searchByTitle', value);
        },
        refreshChecklists() {

            this.updateAll()
                .then(() => {
                    eventBus.$emit('loaded');
                    this.initialLoading = false;
                }, (error) => {
                    eventBus.$emit('client-error', error);
                });
        },
    },
};
</script>
